const dbshop = {
  FORMS: [
    {
      type: 'dbshop-problemas-compra',
      name: 'DBShopProblemasCompraForm',
      message: {
        open: 'Opción Problemas Compra',
        send: 'Envío Formulario Problemas Compra'
      }
    },
    {
      type: 'dbshop-cambio-direccion-entrega',
      name: 'DBShopCambioDireccionEntregaForm',
      message: {
        open: 'Opción Cambio de Dirección Entrega',
        send: 'Envío Formulario Cambio de Dirección Entrega'
      }
    },
    {
      type: 'dbshop-estado-pedido',
      name: 'DBShopEstadoPedidoForm',
      message: {
        open: 'Opción Estado de Pedido',
        send: 'Envío Formulario Estado de Pedido'
      }
    },
    {
      type: 'dbshop-problemas-pedido',
      name: 'DBShopProblemasPedidosForm',
      message: {
        open: 'Opción Problemas de Pedidos',
        send: 'Envío Formulario Problemas Pedido'
      }
    },
    {
      type: 'dbshop-contact-form-order-status',
      name: 'DBShopContactForm',
      message: {
        open: 'Opción Contacto',
        send: 'Envío Formulario Contacto'
      }
    },
    {
      type: 'dbshop-contact-form',
      name: 'DBShopContactForm',
      message: {
        open: 'Opción Contacto',
        send: 'Envío Formulario Contacto'
      }
    }
  ],
  CSS: {
    id: '5fce4248445cf333e49ec44d',
    name: 'dbshop',
    avatar: {
      name: 'Beauty',
      header: 'https://chatbotqa.gatblac.com/static/avatar/dbshop/avatar-reposo.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/dbshop/avatar-inactivo.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/dbshop/avatar-activo.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/dbshop/avatar-reposo.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#efa9a1',
        borderColor: '#efa9a1'
      }
    }
  }
}

export default dbshop
